export const environment = {
    production: false,
    useDevProxy: true,
    backendBaseUrl: "https://sso2.test.satsang.org.in",
    usabackedbaseurl:' https://usa.test.sso.satsang.global/api',
    // backendBaseUrl: "http://localhost:6061",
    orgUrl: 'https://www.test.satsang.org.in/signin-load?login=true',
    accoUrl: 'https://dev.acco.satsang.org.in',
    onlineIvUrl: 'https://oblation.test.satsang.org.in',
    firebase: {
        apiKey: 'AIzaSyCDWivsLjR5ubm-g5jBY7bKwLc6lZgdMfY',
        authDomain: 'sso-test-40504.firebaseapp.com',
        projectId: 'sso-test-40504',
        storageBucket: 'sso-test-40504.firebasestorage.app',
        messagingSenderId: '1060714440281',
        appId: '1:1060714440281:web:07ca684d4f27ebb716b348',
        measurementId: "G-4YGYMTWZ7B"
    },

  firebaseVapidKey: 'BNv2SO7DMtJwo5ld9trGXmEgsYygc3H6aHyKuplFrBj5ZOqMPx8_HTA3k1cTvL4cM3g07gitk4BrGkfLlumU3rg',
  countries: [
    {
      id: 'INDIA',
      title: 'India',
      type: 'phone',
      contactGroups: [
        {
          label: 'Oblation',
          items: [{ value: '+91-9876543210' }, { value: 'oblation@satsangphilanthropy.org' }],
        },
        {
          label: 'Technical Support',
          items: [{ value: '+91-9876543211' }, { value: 'support@satsangphilanthropy.org' }],
        },
      ],
    },
    {
      id: 'NEPAL',
      title: 'Nepal',
      type: 'phone',
      contactGroups: [
        {
          label: 'Contact Us',
          items: [{ value: '+977-9768615361' }, { value: 'satsangnepalphilanthropy@gmail.com' }],
        },
      ],
    },
    {
      id: 'USA',
      title: 'United States',
      type: 'phone',
      contactGroups: [
        {
          label: 'Contact Us',
          items: [{ value: '+1 317-480-3184' }, { value: 'TechSupport@SatsangAmerica.org' }],
        },
      ],
    },
  ],

};
